// KWANKGM00190_案件詳細（マイページ）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import MypageReturn from '../../molecules/MypageReturn';
import FileUpload from '../../templates/FileUpload';
import { ShelfInfoObj, SetShelfInfo } from '../../types/FileUpload';
import ReceptionResult from '../../templates/ReceptionResult';
import AgreementInfo from '../../templates/AgreementInfo';
import SignInfo from '../../templates/SignInfo';
import { KeyValue } from '../../types/KeyValue';
import Heading from '../../molecules/Heading';
import ShowAgreementButton from '../../molecules/ShowAgreementButton';
import ShowContractButton from '../../molecules/ShowContractButton';

interface Props {
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  reception_id: number;
  reception_cd: string;
  reception_sub_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  status_code: number;
  is_staff: boolean;
  guarantors_num: number;
  is_loading: boolean;
  show_error_nav: boolean;
  display_status: boolean;
  callApi: (function_name: string) => Promise<any>;
  guarantor_info: GuarantorInfo;
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  agreement_info: KeyValue[];
  sign_info: KeyValue[];
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
  is_signer: boolean;
}

const SignatureComplete: React.FC<Props> = ({
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  reception_id,
  reception_cd,
  reception_sub_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  status_code,
  is_staff,
  guarantors_num,
  is_loading,
  show_error_nav,
  display_status,
  callApi,
  guarantor_info,
  shelf_info,
  setShelfInfo,
  agreement_info,
  sign_info,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
  is_signer,
}) => {
  return (
    <>
      <TopArea
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      <FileUpload
        shelf_info={shelf_info}
        setShelfInfo={setShelfInfo}
        reception={{
          reception_id: reception_id,
          reception_cd: reception_cd,
          reception_sub_cd: reception_sub_cd,
          ident_lv1_cd: ident_lv1_cd,
          ident_lv2_cd: ident_lv2_cd,
          ident_lv3_cd: ident_lv3_cd,
          status_code: status_code,
        }}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        guarantor_info={guarantor_info}
        is_secured={is_secured}
        is_unsecured={is_unsecured}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      <Heading label="同意・署名" size="m" />
      {/* 連帯債務者等の同意不同意アコーディオン */}
      {/* 連帯債務者等が0人の場合は非表示、1人以上の場合は表示する */}
      {guarantors_num !== 0 && <AgreementInfo agreement_info={agreement_info} heading_disabled />}
      {/* 署名情報アコーディオン */}
      <SignInfo sign_info={sign_info} heading_disabled />
      {/* 同意書を表示するボタン */}
      <ShowAgreementButton reception_id={reception_id} />
      {/* 契約書を表示するボタン */}
      <ShowContractButton reception_id={reception_id} is_signer={is_signer} />
      <MypageReturn is_staff={is_staff} />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default SignatureComplete;
